module.exports = __webpack_public_path__ + "assets/img/36_1441_big.9ce8f78b.jpg";